import React from 'react';
import { Icon, Typography } from '@/components/common';

interface Props {
	title: string;
	name: string;
	image: string;
}

export const InfoCard: React.FC<Props> = ({ title, name, image }) => {
	return (
		<div className="flex items-center gap-2 mt-6">
			<Icon src={image} className="!w-[62px] !h-[62px]" />
			<div>
				<Typography type="semibold-14" className="text-purple-150">
					{title}
				</Typography>
				<Typography type="regular-18">{name}</Typography>
			</div>
		</div>
	);
};
